import { doAttention } from '@/attention';
export function heartBeat(el, duration = undefined, options = {}) {
    return doAttention(el, 'heartBeat', duration, options);
}
//# sourceMappingURL=heartBeat.js.map